import type { FC } from "react";

import { cn } from "../utils";
import { Button, type ButtonProps } from "./button";
import { Icon } from "./icon";

export interface ChipProps extends ButtonProps {
  deletable?: boolean;
  onDelete?: (event: React.MouseEvent<HTMLSpanElement> | React.KeyboardEvent<HTMLButtonElement>) => void;
}

export const Chip: FC<ChipProps> = ({ children, deletable, onDelete, onKeyDown, onFocus, className, ...props }) => {
  const handleDelete: ChipProps["onDelete"] = (e) => {
    e.stopPropagation();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    deletable && onDelete?.(e);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === "Backspace") {
      handleDelete(e);
      return;
    }

    onKeyDown?.(e);
  };

  return (
    <Button
      variant="secondary"
      type="button"
      size="xs"
      onKeyDown={handleKeyDown}
      {...props}
      className={cn("h-[26px] text-xs max-w-full truncate", className)}
    >
      <span className="truncate">{children}</span>
      {deletable && <Icon icon="close" onClick={handleDelete} />}
    </Button>
  );
};
